import { useAuth0 } from "@auth0/auth0-react";

const LoginButton = (props) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    localStorage.setItem('pre_auth_path', window.location.pathname);
    loginWithRedirect();
  };

  return <button {...props} onClick={handleLogin}>LogIn</button>;
};

export default LoginButton;